/**
 * A polly that is written but not started yet, on its way through the first two steps of creating it
 * (polly-page.vue: "Abstimmung", "Über dich"). Nothing is sent to the backend before "Polly starten": a polly
 * exists from the moment it is created, and it is created there, with the creator's name and email.
 *
 * Kept in sessionStorage, so a reload on step 2 - or the way back to step 1 - finds it again, and a
 * closed tab forgets it.
 *
 * Also remembers the (nick)name this device last used in a polly, in localStorage, so step 2
 * and the ballot can suggest it. Only the name: an email address autofills from the browser anyway.
 */

const DRAFT_KEY = "LIQUIDO_POLLY_DRAFT"
const NAME_KEY = "LIQUIDO_POLLY_NAME"

/** @param {{ title: String, proposalTitles: String[] }} draft the question and its options, in order */
export function saveDraft(draft) {
	try {
		sessionStorage.setItem(DRAFT_KEY, JSON.stringify({ title: draft.title, proposalTitles: draft.proposalTitles }))
	} catch (e) {
		console.warn("Polly: cannot keep the draft", e)
	}
}

/** @returns {{ title: String, proposalTitles: String[] } | undefined} the draft, or undefined when there is none */
export function loadDraft() {
	try {
		const draft = JSON.parse(sessionStorage.getItem(DRAFT_KEY) || "null")
		return draft?.title && Array.isArray(draft.proposalTitles) ? draft : undefined
	} catch (e) {
		return undefined
	}
}

export function clearDraft() {
	try {
		sessionStorage.removeItem(DRAFT_KEY)
	} catch (e) { /* nothing we can do */ }
}

/** The name this device last started or voted in a polly with, or "" */
export function rememberedName() {
	try {
		return localStorage.getItem(NAME_KEY) || ""
	} catch (e) {
		return ""
	}
}

/** Forget the remembered name - somebody else uses this device now ("Nicht du?" in polly-page.vue) */
export function forgetName() {
	try {
		localStorage.removeItem(NAME_KEY)
	} catch (e) { /* private mode: nothing remembered */ }
}

export function rememberName(name) {
	try {
		if (name?.trim()) localStorage.setItem(NAME_KEY, name.trim())
	} catch (e) { /* private mode: nothing to remember */ }
}
